import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 5-step collaborative problem-solving flow (steps 0..4)
export const STAGE_META = [
  { stage: 0, title: "Description", short: "Description" },
  { stage: 1, title: "Positions", short: "Positions" },
  { stage: 2, title: "Your needs", short: "Your needs" },
  { stage: 3, title: "Their needs", short: "Their needs" },
  { stage: 4, title: "Strategies", short: "Strategies" },
];

export const TOTAL_STEPS = STAGE_META.length; // 5
export const LAST_STEP = TOTAL_STEPS - 1;      // 4

export const STAGE_OPENER = {
  0: "Hi, I'm your assistant. Together we'll work through a short, calm process to help you handle a conflict in your life. To start: what is this conflict about, and what's happened so far?",
  1: "Now let's name each side's position. A position is the surface of the conflict — the outcome each person is pushing for. What is YOUR position in plain language? (We'll do the other person's next.)",
  2: "Positions are the surface; underneath are needs — the things each person actually cares about (respect, fairness, autonomy, being heard, safety, clarity, support, connection, and so on). What are YOUR deeper needs in this conflict? If you're not sure, you can ask for suggestions.",
  3: "Now a respectful guess about the OTHER person. Underneath their position, what might they be needing or trying to protect? (We're guessing, not diagnosing — and we'll treat these as possibilities.)",
  4: "Now let's bring it together. Arguing over positions usually keeps people stuck. Collaborative problem-solving looks for new — sometimes unexpected — ways to meet both people's deeper needs at once. Here's a draft invitation you could use to start the conversation, plus we'll brainstorm some strategies together.",
};
